export default __webpack_public_path__ + "dist/img/maestro.png";